import React, { useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import {
  Nav,
  NavItem,
  Badge,
} from "reactstrap";

import {
  BsBellFill,
} from "react-icons/bs";

import withRouter from "components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { urlEndPoint } from "helpers/GeneralHelper";
import locationImage from "../../assets/images/location.png";
import userImage from "../../assets/images/usernew.png"
import jobImage from "../../assets/images/job.png"
import noImg from "../../assets/images/no-image.png"

const FunnlsSidebarContent = (props) => {
  const ref = useRef();
  const location = useLocation();
  const userData = JSON?.parse(localStorage.getItem("userData"))
  const pathSegments = location.pathname.split('/');
  let userType = JSON.parse(localStorage.getItem("userType")) || null;

  // Scroll when sidebar mounts
  useEffect(() => {
    if (ref.current?.recalculate) ref.current.recalculate();
  }, []);

  const navItems = [
    {
      to: `${pathSegments[1] == 'all-facilities' ? 'all-facilities' : urlEndPoint.facilityListUrl}`,
      icon: <img src={`${locationImage}`} />,
      label: "Facilities",
    },
    {
      to: `${urlEndPoint.userList}`,
      icon: <img src={`${userImage}`} />,
      label: "Users",
    },
    {
      to: `${urlEndPoint.accountExecutive}`,
      icon:  <i className="bx bxs-user-detail user-icon"></i>,
      label: "Account Executive",
    },
    {
      to: `${urlEndPoint.settings}`,
      icon: <img src={`${jobImage}`} />,
      label: "Settings",
    },
  ];

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        {/* Logo at the top */}
        {/* Menu Icons */}
        <Nav vertical className="mt-4 text-center">
          {navItems.map((item, index) => (
            <NavItem className="mb-2 sidebar-select-width" key={index}>
              <Link
                to={item.to == 'all-facilities' ? `${urlEndPoint.facilityListUrl}` : item.to}
                className={`nav-item-sidebar-link d-flex flex-column align-items-center p-2 rounded ${(pathSegments?.length == 3 ? (`${pathSegments[1]}` === item?.to) : (location.pathname === item?.to))
                    ? "bg-white shadow-sm text-dark w-20 h-20"
                    : "text-dark"
                  }`}
              >
                {item.icon}
                <small className={`mt-1 ${item.label=='Account Executive' ? 'executive-text-pos' : ''}`}>{item.label}</small>
              </Link>
            </NavItem>
          ))}
        </Nav>

        {/* Notification Bell + User Image */}
        <div className="text-center d-flex flex-column align-items-center gap-3 mt-auto mb-4 notification-profile-position">
          {/* Notification Bell */}
          {(userType === 1 || userType === 12) &&
              
              <Link className="page-link" to={`${urlEndPoint.clientSelection}`} >

              <div className="position-relative">
                <i className="bx bxs-user-check change-client"></i>
              </div>
            </Link> 
          }
          <Link className="page-link" to={`${urlEndPoint.notificationList}`} >

            <div className="position-relative">
              <BsBellFill size={20} className="text-dark" />
              <Badge
                color="danger"
                pill
                className="position-absolute notification-bell-position notification-bell-dot"
              >
                &nbsp;
              </Badge>
            </div>
          </Link>

          {/* User Avatar */}
          <Link className="page-link" to={`${urlEndPoint.profileForm}`} >
            <img
              className="rounded-circle header-profile-user"
              src={userData?.UserImageFile || noImg}
              alt="Header Avatar"
            />
          </Link>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

FunnlsSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  isMobile: PropTypes.any
};

export default withRouter(withTranslation()(FunnlsSidebarContent));
